module.exports = __webpack_public_path__ + "img/italy-other-heart-diseases-male.ab081e09.png";